// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__19_w6","location":"Header_location__1A_Np"};